import { MapPin, Clock, Mail } from "lucide-react";
import api from "@/lib/api";
import useApiData from "@/hooks/useApiData";

const Locations = () => {
  const { data: locations, loading } = useApiData(api.getLocations);

  return (
    <div className="pt-16" data-testid="locations-page">
      <section className="bg-[#111] py-16">
        <div className="container-custom">
          <div className="accent-line mb-4" ></div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F2EDE4] mb-3">
            Locations
          </h1>
          <p className="text-[#F2EDE4]/30 max-w-md">
            Three locations across Baltimore and Princeton dedicated to squash training.
          </p>
        </div>
      </section>

      <section className="section bg-[#111]">
        <div className="container-custom">
          {loading ? (
            <div className="text-center py-12 text-[#F2EDE4]/20">Loading...</div>
          ) : (
            <div className="grid md:grid-cols-2 gap-12">
              {locations.map((location) => (
                <div key={location.id} data-testid={`location-${location.id}`}>
                  <div className="aspect-[16/10] overflow-hidden mb-6">
                    <img
                      src={location.image_url}
                      alt={location.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h2 className="font-display text-2xl font-bold text-[#F2EDE4] mb-1">
                    {location.name}
                  </h2>
                  <p className="text-sm text-[#F2EDE4]/30 mb-4">{location.courts} Courts</p>

                  <div className="space-y-2.5 text-sm text-[#F2EDE4]/40 mb-6">
                    <div className="flex items-start gap-2.5">
                      <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#F2EDE4]/20" />
                      <span>{location.address}</span>
                    </div>
                    <div className="flex items-start gap-2.5">
                      <Clock className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#F2EDE4]/20" />
                      <span>{location.hours}</span>
                    </div>
                    <div className="flex items-center gap-2.5">
                      <Mail className="w-4 h-4 flex-shrink-0 text-[#F2EDE4]/20" />
                      <span>{location.email}</span>
                    </div>
                  </div>

                  {location.amenities && (
                    <div className="flex flex-wrap gap-1.5">
                      {location.amenities.map((a, i) => (
                        <span key={a} className="text-xs text-[#F2EDE4]/20 bg-[#090B0C] px-2.5 py-1">
                          {a}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Locations;
